export class StockValuationReportModel{
    mfgCostOnRmForJob: number
    mfgCostOnRm: number
    exchangeRate: number
    productInfo: StockValuationProductInfo[]
    abstractInfo : AbstractInfo[]
    constructor(mfgCostOnRmForJob: number,mfgCostOnRm: number,exchangeRate: number,productInfo: StockValuationProductInfo[], abstractInfo : AbstractInfo[]){
    this.mfgCostOnRmForJob = mfgCostOnRmForJob
    this.mfgCostOnRm = mfgCostOnRm
    this.exchangeRate = exchangeRate
    this.productInfo = productInfo
    this.abstractInfo = abstractInfo

    }

}

export class StockValuationProductInfo{
    grade: string
    variety: string
    masterCartons: number
    loosePouches: number
    fgQtyInKgs: number
    productYield: number
    packCount: number
    rmCount: number
    rmRate: number
    calRmQty: number
    rmValue: number
    mfgCost: number
    netCop: number
    realisationPricePerKg: number
    realisationValue: number
    basis: string

    constructor(grade: string,variety: string,masterCartons: number,loosePouches: number,fgQtyInKgs: number,productYield: number,packCount: number,rmCount: number,rmRate: number,calRmQty: number,rmValue: number,mfgCost: number,netCop: number,realisationPricePerKg: number,realisationValue: number,basis: string){
        this.grade = grade
        this.variety = variety
        this.masterCartons = masterCartons
        this.loosePouches = loosePouches
        this.fgQtyInKgs = fgQtyInKgs
        this.productYield = productYield
        this.packCount = packCount
        this.rmCount = rmCount
        this.rmRate = rmRate
        this.calRmQty = calRmQty
        this.rmValue = rmValue
        this.mfgCost = mfgCost
        this.netCop = netCop
        this.realisationPricePerKg = realisationPricePerKg
        this.realisationValue = realisationValue
        this.basis = basis
    }

}


export class AbstractInfo{
    particulars: string
    qty: number
    cop: number
    copPerKg: number
    realisation: number
    realisationPerKg: number

    constructor( particulars: string,qty: number,cop: number,copPerKg: number,realisation: number,realisationPerKg: number){
        this.particulars = particulars
        this.qty = qty
        this.cop = cop
        this.copPerKg = copPerKg
        this.realisation = realisation
        this.realisationPerKg = realisationPerKg
    }
        
}